<template>
  <div v-if="isLoggedIn" class="card">
    <Toast />
    <form @submit.prevent="save">
      <Toolbar>
        <template v-slot:right>
          <Button
            label="Guardar"
            icon="pi pi-save"
            type="submit"
            @click="submitForm()"
            class="p-button-raised p-button-rounded"
          />
        </template>
      </Toolbar>
      <Divider align="left">
        <div class="p-d-inline-flex p-ai-center">
          <i class="pi pi-id-card p-mr-1"></i>
          <h3>Datos</h3>
        </div>
      </Divider>
      <div class="p-formgroup-inline">
        <div class="form-control" :class="{ invalid: !nombre.isValida }">
          <span class="p-float-label">
            <InputText
              id="nombre"
              type="text"
              @blur="clearValidity('nombre')"
              :maxlength="100"
              size="53"
              v-model="nombre.val"
            />
            <label for="nombre">Nombre</label>
          </span>
        </div>
      </div>
      <div><br /></div>
      <div class="p-formgroup-inline">
        <div class="form-control" :class="{ invalid: !usuario.isValida }">
          <span class="p-float-label">
            <InputText
              id="usuario"
              type="text"
              @blur="clearValidity('usuario')"
              :maxlength="100"
              size="53"
              v-model="usuario.val"
            />
            <label for="usuario">Usuario</label>
          </span>
        </div>
        <div class="flex items-center gap-2">
          <div class="field-checkbox">
            <Checkbox
              id="binary"
              v-model="checked"
              :binary="true"
              class="custom-checkbox"
            />
            <label for="binary"><strong> Administrador</strong></label>
          </div>
        </div>
      </div>
      <div><br /></div>
      <div class="p-formgroup-inline">
        <div></div>
        <div class="form-control">
          <span class="p-float-label">
            <Password
              id="password"
              v-model="password.val"
              @input="validatePassword"
              :maxlength="50"
              size="50"
              toggleMask
              :feedback="false"
            />
            <label for="password">Contraseña</label>
          </span>
          <small v-if="password.error" class="p-error">{{
            password.error
          }}</small>
        </div>
        <div></div>
      </div>
      <div><br /></div>
      <div class="p-formgroup-inline">
        <div class="p-formgroup-inline">
          <div class="form-control" :class="{ invalid: !dispositivo.isValida }">
            <span class="p-float-label">
              <InputText
                id="dispositivo"
                type="text"
                @blur="clearValidity('dispositivo')"
                :maxlength="50"
                size="53"
                v-model="dispositivo.val"
              />
              <label for="dispositivo">ID del dispositivo</label>
            </span>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  emits: ['save-data'],
  data() {
    return {
      formIsValida: true,
      error: null,
      checked: false,
      usuario: { val: '', isValida: true },
      nombre: { val: '', isValida: true },
      estatus: { val: '', isValida: true },
      password: { val: '', isValida: true, error: null },
      dispositivo: { val: '', isValida: true },
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    clearValidity(input) {
      this[input].isValida = true;
    },
    submitForm() {
      this.validForm();

      if (!this.formIsValida) {
        this.$toast.add({
          severity: 'error',
          summary: 'Campos Incorrectos',
          detail: 'Por favor revisar que los campos se encuentren correctos',
          life: 3000,
        });
        return;
      }
      const dataUser = {
        usuario: this.usuario.val,
        nombre: this.nombre.val,
        password: this.password.val,
        estatus: this.checked == false ? '1' : '9',
        dispositivo: this.checked == false ? this.dispositivo.val : '',
      };
      console.log(dataUser);
      this.$emit('save-data', dataUser, null);
      setTimeout(() => {}, 500);
    },
    validForm() {
      this.formIsValida = true;
      if (this.nombre.val === '') {
        this.formIsValida = false;
        this.nombre.isValida = false;
      }
      if (this.usuario.val === '') {
        this.formIsValida = false;
        this.usuario.isValida = false;
      }
      if (this.checked != true) {
        if (this.dispositivo.val === '') {
          this.formIsValida = false;
          this.dispositivo.isValida = false;
        }
      }

      if (this.password.val === '') {
        this.formIsValida = false;
        this.password.isValida = false;
      }
    },
    validatePassword() {
      const regex =
        /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
      if (!regex.test(this.password.val)) {
        this.password.error =
          'La contraseña debe tener al menos 8 caracteres, incluir una mayúscula, un número y un carácter especial.';
      } else {
        this.password.error = null; // Sin error
      }
    },
    handleSubmit() {
      if (!this.password.error && this.password.val) {
        console.log('Contraseña válida:', this.password.val);
        // Aquí puedes enviar el formulario
      } else {
        console.error('Contraseña inválida.');
      }
    },
  },
};
</script>
<style scoped>
/* Contenedor general */
.form-container {
  display: flex;
  flex-wrap: wrap; /* Permite que los elementos bajen a la siguiente línea */
  gap: 1rem; /* Espaciado entre campos */
  width: 100%;
}

/* Estilo de los campos individuales */
.form-control {
  flex: 1 1 300px; /* Toma un ancho base de 300px */
  min-width: 200px; /* Ancho mínimo */
  max-width: 100%; /* Evita que exceda el contenedor */
}

/* Campo inválido */
.form-control.invalid {
  border: 1px solid red;
}

/* Para pantallas pequeñas */
@media (max-width: 768px) {
  .form-control {
    flex: 1 1 100%; /* Ocupa toda la fila en pantallas pequeñas */
  }
}

/* Errores */
.p-error {
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

/* Contenedor del checkbox */
.field-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

/* Borde negro cuando está desmarcado */
.custom-checkbox .p-checkbox-box:not(.p-highlight) {
  border: 3px solid #000000 !important; /* Borde negro cuando NO está marcado */
}

/* Estilos generales del checkbox */
.custom-checkbox .p-checkbox-box {
  width: 30px !important; /* Aumentar tamaño */
  height: 30px !important;
  background-color: #ffffff !important; /* Fondo blanco */
  border-radius: 6px !important; /* Bordes redondeados */
  cursor: pointer;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4); /* Sombra */
  transition: all 0.2s ease-in-out; /* Animación suave */
}

/* Hover para el checkbox */
.custom-checkbox .p-checkbox-box:hover {
  background-color: #e0f7ff !important; /* Fondo más claro */
  border-color: #333333 !important; /* Bordes gris oscuro en hover */
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5); /* Sombra más prominente */
}

/* Checkbox marcado */
.custom-checkbox .p-checkbox-box.p-highlight {
  background-color: #007bff !important; /* Fondo azul cuando está marcado */
  border-color: #0056b3 !important; /* Borde azul cuando está marcado */
}

/* Icono del checkbox */
.custom-checkbox .p-checkbox-icon {
  font-size: 20px !important; /* Ícono más grande */
  color: white !important; /* Ícono blanco */
}
</style>
